<template>
  <div class="left-bar hideBar">
    <router-link to="/bookShelf" v-if="showLogo">
      <div class="logo-box" title="书架首页"><img src="@/assets/images/common/logo.png"></div>
    </router-link>
    <div class="action">
      <slot name="actions"></slot>
    </div>
    <!-- <div class="user-pic-box">
      <el-popover placement="right-end" width="184" trigger="hover" :visible-arrow="false" popper-class="user-popper">
        <div class="user-drop">
          <div class="user-drop-item">个人中心</div>
          <div class="user-drop-item" @click="logout">退出登录</div>
        </div>
        <img slot="reference" src="@/assets/images/common/user-pic.png">
      </el-popover>
    </div> -->
  </div>
</template>

<script>
  import { removeToken } from "@/utils/auth";
  export default {
    name: "sideBar",
    props: {
      showLogo: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      logout() {
        this.$tipsDialog({
          title: '确认退出！',
          iscancel: true,
          beforeClose: (action, target, doClose) => {
            if(action == 'confirm') {
              removeToken()
            }
            doClose()
          },
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .left-bar {
    width: 70px;
    height: 100%;
    padding: 25px 0;
    background: #2F4058;
    position: relative;
    box-shadow: 3px 0 8px 0 rgba(32,37,36,0.2);
    z-index: 5;
    .logo-box {
      width: 44px;
      height: 44px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    .user-pic-box {
      position: absolute;
      bottom: 20px;
      left: 8px;
      width: 54px;
      height: 54px;
      img {
        width: 100%;
      }
    }
  }
  /deep/.user-drop-item{
    height: 57px;
    line-height: 57px;
    text-align: center;
    cursor: pointer;
    border-bottom: 1px solid #f3f5f9;
    &:hover{
      color: #16ca82;
    }
    &:last-child{
      border: 0;
    }
  }
</style>